import Head from 'next/head';
import { CollectionSchema as ICollectionSchema } from './interface';
import { processJsonSchema } from '../utils';

interface NewType {
    config: any;
    dataMeta: ICollectionSchema;
}

type Props = NewType;

const CollectionSchema = ({ config, dataMeta }: Props) => {

    return (
        <Head>
            <script
                id="collection-schema"
                type="application/ld+json"
                dangerouslySetInnerHTML={{
                    __html: processJsonSchema(config, dataMeta)
                }}
            >
                {}
            </script>
        </Head>
    );
};

export default CollectionSchema;
